import { render, staticRenderFns } from "./PuntosDeEntregaListaItem.vue?vue&type=template&id=cb1a2230&"
import script from "./PuntosDeEntregaListaItem.vue?vue&type=script&lang=js&"
export * from "./PuntosDeEntregaListaItem.vue?vue&type=script&lang=js&"
import style0 from "./PuntosDeEntregaListaItem.vue?vue&type=style&index=0&id=cb1a2230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports